import { ActionType } from '../../constants/ActionTypes'
import config from '../../constants/Configs'

import { RestPath } from '../../constants/SitePaths'
import { Constants } from '../../constants/Constants'
import axios from 'axios';
import qs from 'qs'
import Utils from '../../services/Utils';
import { LanguageService } from '../../services/LanguageService';

/* SEO SETTINGS */
export const getSeoSettingsBegin = (data) => ({
    type: ActionType.GET_SEO_SETTINGS_BEGIN,
    payload: data
});

export const getSeoSettingsError = (lang, page, data) => ({
    type: ActionType.GET_SEO_SETTINGS_ERROR,

});

export const getSeoSettingsSuccess = (params, data) => ({
    type: ActionType.GET_SEO_SETTINGS_SUCCESS,
    payload: {
        lang: params.languageId,
        page: params.alias,
        data: data,
        lastUpdated: Date.now()
    }
});

export const setSeoSettingsParams = (lang, data) => ({
    type: ActionType.SET_SEO_SETTINGS_PARAMS,
    payload: {
        lang,
        data: data,
        lastUpdated: Date.now()
    }
});



/** Get SEO Settings */
export function getSeoSettings(params, isRules) {

    params['pathName'] = window.location.pathname;
    params['l'] = LanguageService.getSelectedLanguage();
    return dispatch => {
        dispatch(getSeoSettingsBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${isRules ? RestPath.GET_RULES_SEO_SETTINGS : RestPath.GET_SEO_SETTINGS}`,
            params
        }).then((response) => {
            dispatch(getSeoSettingsSuccess(params, response.data));
        }).catch((error) => {
            dispatch(getSeoSettingsError(error));
        });
    };
}

/** NEW SEO LOGIC */
const CACHE_TIMEOUT = 5 * 60 * 1000 // 5 minutes
const apiCallQueue = Utils.apiCallQueue();

export const setSeoPathParams = (path, blockIds, timestamp) => ({
    type: ActionType.SET_SEO_PATHS_PARAMS,
    path,
    blockIds,
    timestamp
});
export const setSeoContentParams = (blockIds, contents, timestamp) => ({
    type: ActionType.SET_SEO_CONTENT_PARAMS,
    blockIds,
    contents,
    timestamp
});


export function getSeoMatchRules(path) {

    return (dispatch, getState) => {
        apiCallQueue.enqueue(async () => {
            const currentTime = Date.now();
            const storedBlocks = getState().seo.rules.matchPaths[path];

            if (storedBlocks && (currentTime - storedBlocks.timestamp) < CACHE_TIMEOUT) {
                const key = JSON.stringify(storedBlocks.ids);
                if (!getState().seo.rules.content[key] || (currentTime - getState().seo.rules.content[key].timestamp) > CACHE_TIMEOUT) {
                    storedBlocks.ids.length && dispatch(getSeoBlockContent(storedBlocks.ids, currentTime));
                }
            } else {
                try {
                    const l = LanguageService.getSelectedLanguage();
                    const response = await axios({
                        method: Constants.GET,
                        url: `${config.BASE_URL}${RestPath.GET_SEO_MATCH_RULES}`,
                        params: { path, l }
                    });
                    if (response?.data) {
                        const blockIds = response.data;
                        dispatch(setSeoPathParams(path, blockIds, currentTime));
                        if (blockIds.length) {
                            const key = JSON.stringify(blockIds);
                            if (!getState().seo.rules.content[key] || (currentTime - getState().seo.rules.content[key].timestamp) > CACHE_TIMEOUT) {
                                dispatch(getSeoBlockContent(blockIds, currentTime));
                            }
                        }
                    }
                    // ... handle the response ...
                } catch (error) {
                    console.error("Failed to fetch:", error);
                }
            }
        });

    };

}


function getSeoBlockContent(blockIds, timestamp) {
    return dispatch => {
        apiCallQueue.enqueue(async () => {
            try {
                const l = LanguageService.getSelectedLanguage();
                const response = await axios({
                    method: Constants.GET,
                    url: `${config.BASE_URL}${RestPath.GET_SEO_CONTENT}`,
                    params: {
                        ruleIds: blockIds,
                        l
                    },
                    paramsSerializer: function (params) {
                        return qs.stringify(params, { arrayFormat: 'repeat' })
                    }
                })
                if (response?.data) {
                    const contents = response.data;
                    dispatch(setSeoContentParams(blockIds, contents, timestamp));
                }
            } catch (error) {
                console.error("Failed to fetch:", error);
            }
        });
    };
}


